export const detectIsMacOs = () => {
  const userAgent = navigator.userAgent?.toLowerCase();
  return /mac os x/.test(userAgent);
};

/**
 * iPadOS 13+ defaults to "Request Desktop Website", reporting a Macintosh user
 * agent with no iPad token. Real Macs report maxTouchPoints 0, so the touch
 * points are what separate the two.
 */
export const detectIsIpad = (
  userAgent: string = navigator.userAgent,
  maxTouchPoints: number = navigator.maxTouchPoints
) => {
  const ua = userAgent?.toLowerCase() ?? '';
  return /ipad/.test(ua) || (/mac os x/.test(ua) && maxTouchPoints > 1);
};

/**
 * Android phones carry a "mobile" token that tablets omit - the convention
 * Chrome and Samsung Internet follow. Firefox instead says "tablet", which the
 * same rule covers because it drops "mobile" too.
 */
export const detectIsAndroidTablet = (userAgent: string = navigator.userAgent) => {
  const ua = userAgent?.toLowerCase() ?? '';
  return /android/.test(ua) && !/mobile/.test(ua);
};

export const detectIsTablet = (
  userAgent: string = navigator.userAgent,
  maxTouchPoints: number = navigator.maxTouchPoints
) => detectIsIpad(userAgent, maxTouchPoints) || detectIsAndroidTablet(userAgent);
